var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntervenant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#0082de;stroke:#0082de;stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.115 0.115)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(-0.115 -0.115)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6 11.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.132,166h-16.81a.522.522,0,1,0,0,1.043h16.81a.522.522,0,1,0,0-1.043Z",
    transform: "translate(-305.696 -153.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.53,172.395l.042-.055h-.042Z",
    transform: "translate(-305.197 -155.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.393,171.086a13.161,13.161,0,0,0,4.2-9.676h.564a1.591,1.591,0,0,0,.17-3.173,13.239,13.239,0,0,0-8.827-11.363,2.69,2.69,0,0,0-2.645-2.184h-3.288a2.69,2.69,0,0,0-2.645,2.184,13.231,13.231,0,0,0-8.827,11.363,1.591,1.591,0,0,0,.17,3.173h.564v.012a13.177,13.177,0,0,0,4.192,9.664,20.923,20.923,0,0,0-13.82,17.138h1.1A19.885,19.885,0,0,1,312,171.9a11.91,11.91,0,0,0,14.426,0,19.885,19.885,0,0,1,13.7,16.325h1.1A20.92,20.92,0,0,0,327.393,171.086ZM306.257,160.36a.546.546,0,0,1,0-1.092h.322a.521.521,0,0,0,.522-.5,12.169,12.169,0,0,1,7.771-10.762v6.916a.522.522,0,0,0,1.043,0v-7.662a1.648,1.648,0,0,1,1.638-1.529h3.288a1.649,1.649,0,0,1,1.644,1.559c0,.006.006.012.006.018v7.613a.522.522,0,0,0,1.043,0v-6.91a12.165,12.165,0,0,1,7.759,10.756.521.521,0,0,0,.522.5h.322a.546.546,0,0,1,0,1.092Zm19.625,10.428a10.723,10.723,0,0,1-13.346,0,11.908,11.908,0,0,1-4.5-9.367l1.553.018-.018.024,19.3-.055-.018-.042,1.517.024v.012A11.925,11.925,0,0,1,325.883,170.788Z",
    transform: "translate(-297.2 -144.69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntervenant);
export default __webpack_public_path__ + "static/media/intervenant.14d94899ecb0207775e8cf22c7e7d48a.svg";
export { ForwardRef as ReactComponent };